import { render, staticRenderFns } from "./CompetitionsEdit.vue?vue&type=template&id=6ed8d49a&"
import script from "./CompetitionsEdit.vue?vue&type=script&lang=js&"
export * from "./CompetitionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports